// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountBalance } from './account-balance';
import { AccountGroup } from './account-group';
import { AccountTransfer } from './account-transfer';
import { AccountValue } from './account-value';
import { Admin } from './admin';
import { Asset } from './asset';
import { AssetClass } from './asset-class';
import { Bank } from './bank';
import { Batch } from './batch';
import { CounterpartyDatum } from './counterparty-datum';
import { CreditorClaim } from './creditor-claim';
import { CurrencyRate } from './currency-rate';
import { CurrencyType } from './currency-type';
import { Dividend } from './dividend';
import { Liability } from './liability';
import { Lookup } from './lookup';
import { Reconciliation } from './reconciliation';
import { ShareholderClass } from './shareholder-class';
import { SubEntry } from './sub-entry';
import { TaxCode } from './tax-code';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Account extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountId!: number;
  accountCode?: string;
  accountGroupId!: number;
  accountUid!: string;
  adminId!: number;
  adminTypeId?: number;
  assetClassId?: number;
  bankAccountNo?: string;
  bankCity?: string;
  bankId?: number;
  bankPcode?: string;
  bankState?: string;
  bfflags?: number;
  bflastModified?: Date;
  bflastProcessed?: Date;
  bflastTransId?: number;
  bfstatusLookupId?: number;
  bfuid?: string;
  bsb?: string;
  createdBy!: string;
  createdDate!: Date;
  creditorClaimTypeId?: number;
  currencyRateId?: number;
  currencyTypeId!: number;
  data?: number;
  description!: string;
  flags?: number;
  isCore!: boolean;
  isDefault!: boolean;
  isInactive!: boolean;
  isPickable!: boolean;
  lastChqNo?: number;
  lockedDate?: Date;
  longDescription?: string;
  lookupId1?: number;
  lookupId2?: number;
  lookupId3?: number;
  micrline?: string;
  parentAccountAccountId?: number;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  shareHolderClassId?: number;
  taxCodeId?: number;
  trustAdminId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountBalances!: AccountBalance[];
  accountGroup!: AccountGroup;
  accountTransfers!: AccountTransfer[];
  accountValues!: AccountValue[];
  admin!: Admin;
  assetClass!: AssetClass;
  assets!: Asset[];
  bank!: Bank;
  batches!: Batch[];
  bfstatusLookup!: Lookup;
  counterpartyData!: CounterpartyDatum[];
  creditorClaims!: CreditorClaim[];
  currencyRate!: CurrencyRate;
  currencyType!: CurrencyType;
  dividendBankAccountAccounts!: Dividend[];
  dividendEquityAccountAccounts!: Dividend[];
  dividendInSpecieAccountAccounts!: Dividend[];
  dividendTrustAccountAccounts!: Dividend[];
  liabilityAccounts!: Liability[];
  liabilityBankAccounts!: Liability[];
  lookupId1Navigation!: Lookup;
  lookupId2Navigation!: Lookup;
  lookupId3Navigation!: Lookup;
  reconciliations!: Reconciliation[];
  shareHolderClass!: ShareholderClass;
  shareholderClasses!: ShareholderClass[];
  subEntryAccountAccounts!: SubEntry[];
  subEntryContraAccountAccounts!: SubEntry[];
  taxCode!: TaxCode;
}

